import {Component, OnInit, Input, Output, Renderer2, EventEmitter} from '@angular/core';
import {HttpClient} from '@angular/common/http';


@Component({
  selector: 'as-pannel',
  templateUrl: './pannels.component.html',
  styleUrls: ['./pannels.component.scss']
})

export class PannelsComponent implements OnInit {

  @Input() data: any;
  @Input() url: string;
  @Input() type: 'side';
  @Input() action: string;
  @Input() title: string;
  @Input() id;
  // @Input() ajax: boolean = false
  // @Input() saveButton: string;
  @Input() count : number = 0;
  @Input() button: 'minimal' | 'flat' | 'link' | 'default' | 'ellipsis' | 'filter' | 'settings' | 'calendar';
  @Input() hideParentScroll: boolean = false;
  @Input() disableButton: boolean= false;

  @Output() outputData = new EventEmitter();
  @Output() panelClosed = new EventEmitter()

  constructor(
    private http: HttpClient,
    private renderer: Renderer2
  ) {
  }

  hidden: boolean = true;
  initial: boolean = true;
  preloader: boolean = true;

  ngOnInit() {
  }

  public btnAction(action?) {

    if (action != "close") {
      //inform parent that it was clicked and to get data
      this.outputData.emit(true);
    }

    this.panelClosed.emit(action == "close")

    // if(this.ajax && action != "close"){
    //     this.http.get(this.url).subscribe((e)=>{
    //       this.outputData.emit(e)
    //       this.preloader = false;
    //     })
    // }


    if (this.hideParentScroll) {
      if (this.hidden) {
        this.renderer.addClass(document.body, 'pannel-open');

      } else {
        this.renderer.removeClass(document.body, 'pannel-open');
      }
    }
      this.hidden = !this.hidden;
      this.initial = false;


  }

  closePanel(){
      this.panelClosed.emit(true)
      this.hidden = true;
      this.initial = false;
  }

}
